import { Flex, theme } from 'antd'
import { useMoneyflowLoading } from "../../hooks/useMoneyflowLoading"
import { LoadingCard } from "../common/LoadingCard.tsx"
import { ReactNode } from "react"

export const DiagramLoadingCard = ({ children }: { children: ReactNode[] }) => {
    const loading = useMoneyflowLoading()
    const { token } = theme.useToken()

    return <>
        {loading &&
            <Flex justify="center" align="center" style={{ height: '100%', width: '100%', position: 'absolute' }}>
                <div style={{ height: '100%', width: '100%', background: token.colorBgBase, opacity: 0.8, position: 'absolute', zIndex: 2 }} />
                <LoadingCard
                    alt='Tracking funds...'
                    content="MoneyFlow tracks funds securely..."
                    title="While you wait,"
                    cardStyle={{ zIndex: 3, width: '320px', height: '270px' }}
                ></LoadingCard>
            </Flex>}
        {children}
    </>
}
